import { APP_INITIALIZER, importProvidersFrom, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HttpClient, HttpContext, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { JwtModule } from "@auth0/angular-jwt";
import { AuthService } from '@core/services/auth.service';
import { authInterceptor, IS_PUBLIC } from '@core/interceptors/auth.interceptor';
import { languageParamInterceptor } from '@core/interceptors/http.interceptor';
import { Observable } from 'rxjs';
import { PaymentAdyenConfirmedComponent } from '@features/payment/pages/payment-adyen-confirmed/payment-adyen-confirmed.component';

export class MyTranslateLoader implements TranslateLoader {
  private readonly CONTEXT = {context: new HttpContext().set(IS_PUBLIC, true)};
  constructor(private http: HttpClient, public prefix: string = "/assets/i18n/", public suffix: string = ".json") {}

  public getTranslation(lang: string): Observable<Object> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`, this.CONTEXT);
  }
}

export const LANGUAGE_KEY = 'MyPassfeet-default-lang';

export function initializerFactory(authService: AuthService) {
  return () => authService.refreshToken();
}

@NgModule({
  declarations: [
    AppComponent,
    PaymentAdyenConfirmedComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new MyTranslateLoader(http),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, languageParamInterceptor])),
    importProvidersFrom([
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem("token")
        }
      })
    ]),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translateService: TranslateService) {
    translateService.setDefaultLang(localStorage.getItem(LANGUAGE_KEY) ?? 'fr');
    translateService.use(localStorage.getItem(LANGUAGE_KEY) ?? 'fr');
  }
}
